import { render, staticRenderFns } from "./productfilter.vue?vue&type=template&id=3a60da77&"
import script from "./productfilter.vue?vue&type=script&lang=ts&"
export * from "./productfilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a60da77')) {
      api.createRecord('3a60da77', component.options)
    } else {
      api.reload('3a60da77', component.options)
    }
    module.hot.accept("./productfilter.vue?vue&type=template&id=3a60da77&", function () {
      api.rerender('3a60da77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/products/productfilter.vue"
export default component.exports